<template>
  <div class="Wdgt-Content-Popup">
    <div class="Wdgt-Content-Popup__close" :class="get_closeBtnClass">
      <ButtonClose :type="'white-fill'" @click="toClose"/>
    </div>
    <div class="Wdgt-Content-Popup__scroll" @click.self="toClose" @scroll="handleScroll" data-content-scroll-wrapper>
      <div class="Wdgt-Content-Popup__wrapper Anim-Call-Auth-Widget__wrapper" ref="scrollBox">
        <!--Новости, материалы, мнения-->
        <template v-if="get_isInfonoise">
          <ContentWidget v-if="get_isContentModule" :key="get_idPost" :commentsPlace="'popup'" />
          <div class="Wdgt-Content-Popup__loader" v-else>
            <LoaderCircle :color="'var(--blue-600)'" :size="48"/>
          </div>
        </template>
        <!--Сигналы-->
        <template v-else-if="get_isSignal">
          <SignalContent :commentsPlace="'popup'" v-if="get_isSignalModule" />
          <div class="Wdgt-Content-Popup__loader" v-else>
            <LoaderCircle :color="'var(--blue-600)'" :size="48"/>
          </div>
        </template>
        <template v-if="get_isLockPaidContent">
          <SubscriptionContent class="Wdgt-Content-Popup__stub" v-if="SHOWED_NEW_SUBSCRIPTION" />
          <StubContent class="Wdgt-Content-Popup__stub" v-else />
        </template>
       
      </div>
    </div>
    <transition name="Anim-Arrow-Up-Button">
      <div class="Wdgt-Content-Popup__up-btn" v-if="isButtonCloseOffset" :class="get_upBtnClass">
        <ButtonUp :type="'white-fill'" :selector="get_scrollBoxSelector"/>
      </div>
    </transition>

  </div>
</template>

<script setup>
  import { computed, ref, onMounted, onUnmounted } from 'vue';
  import { useStore } from 'vuex';
  import { useRoute } from 'vue-router';
  import { throttle } from 'lodash';
  import { getPostData } from '@shared/api/posts/getPostData';
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName';
  import { SHOWED_NEW_SUBSCRIPTION } from '@shared/constants/globalValues/global';
  //-----------------------------------------------
  import ContentWidget from './widgets/MainContent/ContentWidget';
  import SignalContent from './widgets/SignalContent/SignalContent';
  import ButtonUp from '@ui/Buttons/ButtonUp/ButtonUp.vue';
  import ButtonClose from '@ui/Buttons/ButtonClose/ButtonClose.vue';
  import LoaderCircle from '@ui/Loaders/LoaderCircle/LoaderCircle.vue';
  import StubContent from "@ui/Stubs/StubContent/StubContent.vue";
  import SubscriptionContent from "@widgets/Header/components/Subscription/SubscriptionContent/SubscriptionContent.vue";
  //-----------------------------------------------
  const store = useStore();
  //-----------------------------------------------
  const THROTTLE_SCROLL_TIME = 350;
  const HEIGHT_OFFSET_BUTTON = 100;
  const POPUP_NAME = DROPDOWN_NAMES.contentPage;
  //-----------------------------------------------
  const scrollBox = ref(null);
  const isButtonCloseOffset = ref(false);
  const isMovedArrowButton = ref(false);
  //-----------------------------------------------
  onMounted(() => {
    if(get_isInfonoise.value){
      initPostData();
    }else if(get_isSignal.value){
      initSignalData();
    }
  });
  onUnmounted(() => {
    toReturnLastVisitedPageUrl();
    isButtonCloseOffset.value = false;
    isMovedArrowButton.value = false;
  });
  //-----------------------------------------------
  //Поднять кнопку закрыть выше при просроливании попапа
  const get_closeBtnClass = computed(() => isButtonCloseOffset.value ? 'Wdgt-Content-Popup__close--moved' : '');
  //Поднять кнопку 'На вверх' выше при проскроливании к низу
  const get_upBtnClass = computed(() => isMovedArrowButton.value ? 'Wdgt-Content-Popup__up-btn--moved' : '');
  //Получить селектор скролл бокса для кнопки 'Подняться на верх'
  const get_scrollBoxSelector = computed(() => scrollBox.value);
  //Получить ID
  const get_idPost = computed(() => {
    const path = window.location.pathname;
    const segments = path.split('/');
    return segments[segments.length - 1];
  })
  //Получить словарь альфа
  const get_alpha = computed(() => store.state.ContentSystem.Alpha.list);
  //Получить словарь новостей
  const get_news = computed(() => store.state.ContentSystem.Infonoise.list);
  //Это из колонки инфошума
  const get_isNews = computed(() => get_news.value.hasOwnProperty(get_idPost.value));
  //Это из колонки альфа
  const get_isAlpha = computed(() => get_alpha.value.hasOwnProperty(get_idPost.value));
  //Получить объект для передачи
  const get_post = computed(() => {
    if(get_isNews.value) return get_news.value[get_idPost.value];
    else if(get_isAlpha.value) return get_alpha.value[get_idPost.value];
  });
  //Пользователь не имеет доступа к закрытому контенту (нет платной подписки)
  const get_isLockPaidContent = computed(() => !store.getters['UserSystem/hasPaidAccess']);
  //Проверить, есть ли данные о выбранном посте в словаре
  const get_isShowInnerPage = computed(() => {
    if(get_isNews.value || get_isAlpha.value){
      return (get_post.value['is_ready_inner_page']) ? true : false;
    }
    return false;
  });
  //Проверить, есть ли данные о выбранном сигнале в словаре
  const get_isShowInnerSignalPage = computed(() => {
    const id = get_idPost.value;
    return (store.state.OldSignals.data[id]) ? true : false;
  })
  //Отображать ли модуль контента
  const get_isContentModule = computed(() => get_isLockPaidContent.value || get_isShowInnerPage.value);
  //Отображать ли моудль сигнала
  const get_isSignalModule = computed(() => get_isLockPaidContent.value || get_isShowInnerSignalPage.value);
  //Идет ли подгрузка новых комментариев
  const get_isLoadingNewComment = computed(() => store.state.ContentSystem.Comments['popupComments'].isLoadingNext);
  //Готова ли ссылка для получения следующих комментариев
  const get_isCommentsReady = computed(() => store.state.ContentSystem.Comments['popupComments'].nextPageUrl);
  //Это инфошум?
  const get_isInfonoise = computed(() => {
    const type = window.location.pathname.split('/')[1];
    return ['news', 'material', 'opinion'].includes(type);
  });
  //Это сигналы
  const get_isSignal = computed(() => {
    return window.location.pathname.split('/')[1] === 'signal';
  });
  //-----------------------------------------------
  //Закрыть попап
  const toClose = () => {
    store.dispatch('Dropdowns/removeTheDropdown', POPUP_NAME);
  };
  //Действия при скролле страницы
  const handleScroll = throttle((e) => {
    moveCloseButtons(e);
    moveArrowButton(e);
    toLoadNextComment(e)
  }, THROTTLE_SCROLL_TIME);
  //Определяем, если попап был проскролен, то отметить, что кнопка закрытия должна быть смещена
  const moveCloseButtons = (e) => {
    const scrollY = e.target.scrollTop;
    isButtonCloseOffset.value = (scrollY >= HEIGHT_OFFSET_BUTTON) ? true : false;
  }
  //Вернуть урл в строку предыдущей страницы
  const toReturnLastVisitedPageUrl = () => {
    const previousURL = store.state.ContentSystem.lastVisitedUrl;
    window.history.replaceState({}, '', previousURL);
  }
  //Подвигаем кнопку Up если скролл достиг конца
  const moveArrowButton = (e) => {
    const scrollBox = e.target;
    const scrollTop = scrollBox.scrollTop;
    const scrollHeight = scrollBox.scrollHeight;
    const clientHeight = scrollBox.clientHeight;
    const bottomOffset = scrollHeight - clientHeight - scrollTop;
    const threshold = 50;
    isMovedArrowButton.value = (bottomOffset < threshold) ? true : false;
  }
  //Инициализировать данные поста, если они отсутствуют в хранилище
  const initPostData = async () => {
    if (get_isShowInnerPage.value || get_isLockPaidContent.value) return;
    const data = await getPostData(get_idPost.value);
    const type = data.section_name;
    const list = (type === 'opinion' || type === 'material') ? get_alpha.value : get_news.value;
    data['is_ready_inner_page'] = true;
    const { last_comment, ...rest } = data;
    list[get_idPost.value] = { ...list[get_idPost.value], ...rest };
  };
  //Получить сигнал, если он отсутсвует в хранилище
  const initSignalData = () => {
    const signal = store.state.OldSignals.data[get_idPost.value];
    if(signal) return;
    store.dispatch('OldSignals/getAndAddTheSignal', get_idPost.value);
  }
  //Подгрузить новые комментарии, если скролл достиг конца
  const toLoadNextComment = (e) => {
    const scrollBox = e.target;
    const scrollTop = scrollBox.scrollTop;
    const scrollHeight = scrollBox.scrollHeight;
    const clientHeight = scrollBox.clientHeight;
    const isAtBottom = scrollHeight - (scrollTop + clientHeight) <= 1100;
    if (isAtBottom) {
      if(get_isLoadingNewComment.value || !get_isCommentsReady.value) return;
      store.dispatch('ContentSystem/Comments/loadNextComments', { context: 'popupComments' });
    }
  };
</script>

<style lang="scss">
  @import './styles/_conf';
</style>
